import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_VENDORS,
  // GET_ADMIN_PROFILE,
  ADD_NEW_VENDOR,
  UPDATE_VENDOR,
  DELETE_VENDOR,
  GET_VENDOR_PROFILE,
  SET_PAGE,
  SET_OFFSET,
  SET_QUERY,
} from "./actionTypes"
import {
  getVendorsSuccess,
  getVendorsFail,
  addVendorSuccess,
  addVendorFail,
  updateVendorSuccess,
  updateVendorFail,
  deleteVendorSuccess,
  deleteVendorFail,
  getVendorProfileSuccess,
  getVendorProfileFail,
  setOffset,
  setPage,
  // getVendorProfileSuccess,
  // getVendorProfileFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getVendors,
  // getVendorProfile,
  addNewVendor,
  updateVendor,
  deleteVendor,
  getVendorProfile,
} from "../../helpers/backend_helper"
import { setDataEdit, showPopup } from "../popup/actions"

function* fetchVendors({ payload }) {
  try {
    const response = yield call(getVendors, payload)
    console.log({ response })
    yield put(getVendorsSuccess(response))
  } catch (error) {
    yield put(getVendorsFail(error))
  }
}

function* fetchVendorProfile({ payload }) {
  try {
    const response = yield call(getVendorProfile, payload)
    yield put(getVendorProfileSuccess(response))
    yield put(setDataEdit(response.coveredLocation))
  } catch (error) {
    yield put(getVendorProfileFail(error))
  }
}

function* onUpdateVendor({ payload: { vendor, history } }) {
  try {
    let response = yield call(updateVendor, vendor)
    //  if(response.file_src || vendor.removeImage) vendor.image = response.file_src
    delete vendor.types
    yield put(updateVendorSuccess(vendor))
    yield put(showPopup({ title: response.message, success: true }))
    if (vendor.is_active == 1) {
      history && history.push("/vendors")
    } else {
      history && history.push("/pending_vendors")
    }
  } catch (error) {
    yield put(updateVendorFail(error))
    yield put(showPopup({ title: error.response.data.message, error: true }))
  }
}

function* onDeleteVendor({ payload: vendor }) {
  try {
    let response = yield call(deleteVendor, vendor)
    yield put(deleteVendorSuccess(vendor))
    yield put(showPopup({ title: response.message, success: true }))
  } catch (error) {
    yield put(deleteVendorFail(error))
    yield put(showPopup({ title: error.response.data.message, error: true }))
  }
}

function* onAddNewVendor({ payload: { user, history } }) {
  try {
    let response = yield call(addNewVendor, user)
    yield put(addVendorSuccess(response.data))
    yield put(showPopup({ title: response.message, success: true }))

    history.push("/vendors")
  } catch (error) {
    yield put(addVendorFail(error))
    // yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* _setPage(payload) {
  try {
    yield put(_setPage(payload))
  } catch (error) {}
}

function* _setOffset(payload) {
  try {
    yield put(_setOffset(payload))
  } catch (error) {}
}

function* _setQuery(payload) {
  try {
    yield put(_setQuery(payload))
  } catch (error) {}
}

// function* fetchVendorProfile() {
//   try {
//     const response = yield call(getVendorProfile);
//     yield put(getVendorProfileSuccess(response));
//   } catch (error) {
//     yield put(getVendorProfileFail(error));
//   }
// }

function* vendorsSaga() {
  yield takeEvery(GET_VENDORS, fetchVendors)
  yield takeEvery(GET_VENDOR_PROFILE, fetchVendorProfile)
  yield takeEvery(ADD_NEW_VENDOR, onAddNewVendor)
  yield takeEvery(UPDATE_VENDOR, onUpdateVendor)
  yield takeEvery(DELETE_VENDOR, onDeleteVendor)
  yield takeEvery(SET_PAGE, _setPage)
  yield takeEvery(SET_OFFSET, _setOffset)
  yield takeEvery(SET_QUERY, _setQuery)
  // yield takeEvery(GET_ADMIN_PROFILE, fetchVendorProfile);
}

export default vendorsSaga
